export default "__VITE_ASSET__B8kn3aOM__"